export default {
  name: 'RuleEditor',
  props: {
    template: {
      type: Object,
      required: true
    },
    isProductiveVersion: {
      type: Boolean,
      optional: true,
      default: false
    },
    readonly: {
      type: Boolean,
      optional: true,
      default: false
    }
  },
  data: function () {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    emitUnsavedChanges(template) {
      this.$emit('update-unsaved-changes', template);
    }
  }
};